/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IContactDetails } from 'app/shared/model/contact-details.model';
import { IDiagLab } from 'app/shared/model/diag-lab.model';

export interface IDiagLabSupplier {
  id?: string;
  supplierName?: string | null;
  taxCode?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  contactCode?: IContactDetails;
  diagLab?: IDiagLab;
}

export const defaultValue: Readonly<IDiagLabSupplier> = {
  active: false,
};
